import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const scrollToTopAndNavigate = useCallback((path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  }, [navigate]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/'); }}
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-play-circle-fill text-xl text-background-50"></i>
            </div>
            <span
              className="text-xl font-heading font-bold"
              style={{ color: isScrolled || !isHome ? 'oklch(var(--primary-500))' : 'white' }}
            >
              奶泡动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
                  : location.pathname === '/' ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/all'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
                  : location.pathname.startsWith('/category') ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              番剧分类
            </Link>
            <Link
              to="/about"
              onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/about'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome
                  ? location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
                  : location.pathname === '/about' ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg"
            style={{ color: isScrolled || !isHome ? 'oklch(var(--foreground-700))' : 'white' }}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/'); }}
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/category/all'); }}
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              番剧分类
            </Link>
            <Link
              to="/about"
              onClick={(e) => { e.preventDefault(); scrollToTopAndNavigate('/about'); }}
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about' ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}